import './Card.371bbb5c10316a3cc3e3822dc210e612.css';
export default {"card":"_card_dwqtr_1","shadow":"_shadow_dwqtr_1"};